export const getRouteRegex = (route) => new RegExp(`\\/(${route})\\b`);

export function getCurrentEnumRoute(path: string, enumObj: object): string {
  const matchExec = getRouteRegex(Object.values(enumObj).join("|")).exec(path);
  if (!matchExec) return null;
  return matchExec[1]; // return match
}

export function getPathParams(path: string): string[] {
  return path.split("/");
}
